import React, { Component } from "react";
import IdCardRequest from "../Components/IdCard/IdCardRequest";
import ServiceGate from "../Components/ServiceGate";

class IdCardRequestPage extends Component {
  render() {
    return (
      <div className="jumbotron">
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
              >
                <div style={{ marginLeft: 0, fontWeight: 700 }}>
                  ID Card Application
                </div>
              </h3>
              <hr />

              <ServiceGate service="id_card">
                <IdCardRequest {...this.props} />
              </ServiceGate>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IdCardRequestPage;
